import * as yup from 'yup';
import { inputAmountValidation } from 'util/validation';
import { minAmount } from './forms/Paybis/constants';

export const paybisQuoteValidation = yup.object().shape({
  amount: inputAmountValidation({
    coin: 'USDT',
    min: minAmount,
    maxDecimals: 2,
  }),
  currency: yup.string().required('common:required'),
  method: yup.string().required('common:required'),
});
